import instance from '../api';
import { message } from 'antd';
import { ErrorNotification } from '../../Utils/data';

export const camera = {
  async read(
    isAssign?: boolean | null,
    companyId?: string | number,
    imei?: string,
    model?: string,
    skip?: string | number,
    status?: string,
  ) {
    try {
      const params = new URLSearchParams();

      if (skip !== undefined) params.append('page', String(skip));
      if (companyId) params.append('companyId', String(companyId));
      if (imei) params.append('imei', imei);
      if (model) params.append('model', model);

      if (typeof isAssign === 'boolean') {
        params.append('isAssign', String(isAssign));
      }

      if (status) {
        params.append('status', status);
      }

      const { data }: any = await instance.get(`dvrs/admin/list?${params.toString()}`);

      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      ErrorNotification({
        status: error?.response?.status,
        message: error?.response?.data?.error?.message,
      });
    }
  },

  async SIMCardsRead(
    companyId?: string | number,
    imei?: string,
    model?: string,
    skip?: string | number,
    simStatus?: string,
  ) {
    if (model === undefined) model = '';
    if (companyId === undefined) companyId = '';
    if (simStatus === undefined) simStatus = '';

    try {
      const { data }: any = await instance(
        `dvrs/admin/list?page=${skip}&companyId=${companyId}&imei=${imei}&model=${model}&simStatus=${simStatus}`,
      );
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async cameraFindOne(id: string | number) {
    if (id) {
      try {
        const { data }: { data: any } = await instance(`dvrs/admin/find/${id}`);
        return data;
      } catch (error: any) {
        if (error.response && error.response.status) {
          ErrorNotification({
            status: error.response.status,
            message: error.response.data.error.message,
          });
        }
      }
    }
  },

  async cameraPatch(id: any, body: any) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`dvrs/admin/edit/${id}`, {
        method: 'PATCH',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async addCamera(body: number | string) {
    message.loading({ content: 'Loading...', key: body });
    try {
      const { data } = await instance('dvrs/admin/create', {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key: body, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async modelSelect() {
    const { data }: any = await instance(`dvrs/model-names`);
    return {
      data: data,
    };
  },

  async cameraCompanyFinder(search: string) {
    if (typeof search === 'string') {
      search = search.trim();
    }
    const { data }: any = await instance(
      `userCompanies/companies?search=${encodeURIComponent(search)}&isActive=true`,
    );
    return data?.data;
  },

  async vehicleList(companyId?: number | string, truck?: string | number) {
    try {
      if (truck === undefined) truck = '';
      if (companyId === undefined) companyId = '';
      const { data }: any = await instance(
        `vehicles/searching-list?page=1&perPage=1000&truckSearch=${truck}&companyId=${companyId}&isActive=true`,
      );
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async pushEventsData(imei: string, status: string, skip: string | number = 1) {
    if (status === undefined) status = '';
    try {
      const { data }: any = await instance(
        `dvrs/admin/push-events?page=${skip}&imei=${imei}&type=${status}`,
      );
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async pushAlertsData(imei: string, status: string, skip: string | number = 1) {
    if (status === undefined) status = '';
    try {
      const { data }: any = await instance(
        `dvrs/admin/push-alerts?page=${skip}&imei=${imei}&type=${status}`,
      );
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
  async commandDashcams(skip: string | number, status: string, dvrId: string, type: string) {
    try {
      const { data }: { data: any } = await instance(
        `commandDashcams/list?page=${skip}&perPage=10&status=${status}&dvrId=${dvrId}&type=${type}`,
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async addCommandDashcams(body: any) {
    message.loading({ content: 'Loading...', key: body });
    try {
      const { data } = await instance('commandDashcams/create-by-string', {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key: body, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async commandDashcamsById(id: string | number) {
    if (id) {
      try {
        const { data }: { data: any } = await instance(`commandDashcams/${id}/creator`);
        return data;
      } catch (error: any) {
        if (error.response && error.response.status) {
          ErrorNotification({
            status: error.response.status,
            message: error.response.data.error.message,
          });
        }
      }
    }
  },
  async commandDashcamsTypes() {
    try {
      const { data }: { data: any } = await instance(`commandDashcams/types`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async commandDashcamsPatch(commandId: string, body: any) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`/commandDashcams/edit/${commandId}`, {
        method: 'PATCH',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async deleteCommandDashcams(commandId: string | undefined) {
    message.loading({ content: 'Loading...', key: commandId });
    let res;
    let error = '';
    try {
      const { data } = await instance(`commandDashcams/delete/${commandId}`, {
        method: 'DELETE',
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Deleted!', key: commandId, duration: 2 });
        }, 1000);
        return u;
      });
      res = data;
    } catch (err) {
      error = 'Oops something went wrong!';
    }
    return { data: res, error };
  },

  async initialCommandsList(page: number | string = 1, perPage: number | string = 10) {
    try {
      const { data } = await instance(`/initial-commands/list?page=${page}&perPage=${perPage}`);

      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async initialCommandsCreate(payload: { type: string; value: string }) {
    try {
      const { data } = await instance.post('/initial-commands/create', payload);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async initialCommandsEdit(
    initialCommandId: string,
    payload: {
      type: string;
      value: string;
    },
  ) {
    try {
      const { data } = await instance.patch(
        `/initial-commands/edit?initialCommandId=${initialCommandId}`,
        payload,
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async initialCommandsDelete(initialCommandId: string) {
    try {
      const { data } = await instance.delete(
        `/initial-commands/delete?initialCommandId=${initialCommandId}`,
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async initialCommandsTypeList() {
    try {
      const { data } = await instance('/initial-commands/type-list');
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      throw error;
    }
  },
  async updateMultipleInitialCommands(payload: any) {
    try {
      const { data } = await instance.put('/initial-commands/multiple-edit', payload);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data?.error?.message,
        });
      }
      throw error;
    }
  },

  async fetchAlertsAdminList(params: {
    page?: number | string;
    perPage?: number;
    startOfDay?: string;
    endOfDay?: string;
    status?: string;
    events?: string;
    driverId?: string | number;
    vehicleId?: string | number;
    companyId?: number | string;
  }) {
    try {
      const { data } = await instance.get('/alerts/admin/list', {
        params,
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      throw error;
    }
  },

  async sendInitialCommands(params: { cameraIds: string[] }) {
    try {
      const { data } = await instance.post('/commandDashcams/initial-commands', params);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error?.message || 'Unknown error',
        });
      }
      throw error;
    }
  },

  async sendCommandToCamera(payload: {
    command: string;
    commandType: string;
    dvrId: string | number;
    vehicleId?: string | number;
    companyId?: string | number;
    imei?: string | number;
  }) {
    const key = 'send-command-to-camera';
    message.loading({ content: 'Sending command...', key });

    try {
      const { data } = await instance.post('/admins/send-command-to-camera', payload);
      message.success({ content: 'Command sent!', key, duration: 2 });
      return data;
    } catch (error: any) {
      message.destroy(key);
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error?.message || 'Unknown error',
        });
      }
      throw error;
    }
  },
};
